// extracted by mini-css-extract-plugin
export default {"meinian-inspiration-analysis":"index_meinian-inspiration-analysis__fzOVP"};